import { render } from "./PromocodesWindow.vue?vue&type=template&id=2096d69f&scoped=true"
import script from "./PromocodesWindow.vue?vue&type=script&lang=js"
export * from "./PromocodesWindow.vue?vue&type=script&lang=js"

import "./PromocodesWindow.vue?vue&type=style&index=0&id=2096d69f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2096d69f"]])

export default __exports__